module.exports = __webpack_public_path__ + "media/printed-materials/image021-543726d8.jpg";